export enum Ethnicity {
  WHITE = 'White',
  BLACK = 'Black',
  BROWN = 'Brown',
  YELLOW = 'Yellow',
  INDIGENOUS = 'Indigenous'
}
